import React from 'react';
import CustomModal from '../../common/modal/modal';
import UniversalLoaderForComponent from '../../loader/universalLoaderForComponent';
import { getHistoryValue } from './print-utility';

const HistoryModal = ({
    show,
    setShow,
    patientName,
    patientDetails,
    historyReports,
    allTestsMap,
    isLoadingHistory,
    visitFilter,
    onVisitFilterChange,
    onPrint
}) => {
    const getHistoryValueForTable = (testId, date, isBreakdown = false, breakdownName = '') => {
        return getHistoryValue(historyReports, testId, date, isBreakdown, breakdownName);
    };

    return (
        <CustomModal
            autoClose={true}
            size="xl"
            show={show}
            setShow={setShow}
            customClass="follow-up-history-modal"
        >
            <div className='history-modal-content'>
                <div className='history-modal-header p-3 border-bottom d-flex justify-content-between align-items-center'>
                    <h5 className='mb-0'>Investigations profile - {patientDetails?.name || patientName}</h5>
                    <div className='d-flex align-items-center gap-2'>
                        <label className='mb-0' style={{ fontSize: '13px', fontWeight: '500' }}>Show:</label>
                        <select
                            className='form-select form-select-sm mr-4 py-1'
                            value={visitFilter === null ? 'all' : visitFilter.toString()}
                            onChange={onVisitFilterChange}
                            disabled={isLoadingHistory}
                            style={{
                                fontSize: '13px',
                                width: 'auto',
                                minWidth: '120px',
                                cursor: isLoadingHistory ? 'not-allowed' : 'pointer'
                            }}
                        >
                            <option value="3">Last 3 visits</option>
                            <option value="7">Last 7 visits</option>
                            <option value="14">Last 14 visits</option>
                            <option value="all">All visits</option>
                        </select>
                        <button
                            className='btn btn-sm'
                            onClick={onPrint}
                            disabled={isLoadingHistory || historyReports.length === 0}
                            style={{
                                backgroundColor: '#14A67D',
                                color: 'white',
                                fontSize: '13px',
                                padding: '5px 16px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: isLoadingHistory || historyReports.length === 0 ? 'not-allowed' : 'pointer',
                                opacity: isLoadingHistory || historyReports.length === 0 ? 0.6 : 1
                            }}
                        >
                            Print
                        </button>
                    </div>
                </div>

                <div className='history-table-container p-3' style={{ minHeight: '70vh' }}>
                    {isLoadingHistory ? (
                        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '70vh' }}>
                            <UniversalLoaderForComponent />
                        </div>
                    ) : (
                        <>
                            {historyReports.length === 0 ? (
                                <p className='text-center text-muted p-4'>No Investigations profile found</p>
                            ) : (
                                <div className='table-responsive' style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    <table className='table table-bordered table-sm history-comparison-table'>
                                        <thead className='sticky-top' style={{ background: '#f5f5f5', zIndex: 10 }}>
                                            <tr>
                                                <th className='test-name-col' style={{ minWidth: '200px', position: 'sticky', left: 0, background: '#f5f5f5', zIndex: 11 }}>
                                                    Test Name
                                                </th>
                                                {historyReports.map((report, idx) => (
                                                    <th key={idx} className='date-col text-center' style={{ minWidth: '150px' }}>
                                                        {new Date(report.date).toLocaleDateString()}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.values(allTestsMap).map((test) => (
                                                <React.Fragment key={test._id}>
                                                    {/* Main Test Row */}
                                                    <tr>
                                                        <td className='test-name-cell' style={{ position: 'sticky', left: 0, background: 'white', fontWeight: '600', color: '#14A67D' }}>
                                                            {test.name}
                                                        </td>
                                                        {historyReports.map((report, idx) => {
                                                            const value = getHistoryValueForTable(test._id, report.date, false);
                                                            return (
                                                                <td key={idx} className='text-center value-cell'>
                                                                    {value || '-'}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>

                                                    {/* Breakdown Rows */}
                                                    {test.breakdowns && test.breakdowns.length > 0 && test.breakdowns.map((breakdown, breakdownIdx) => (
                                                        <tr key={`${test._id}-${breakdownIdx}`} className='breakdown-row'>
                                                            <td className='test-name-cell breakdown-name' style={{ position: 'sticky', left: 0, background: 'white', paddingLeft: '30px' }}>
                                                                <span style={{ fontSize: '12px', color: '#666' }}>{breakdown.name}</span>
                                                            </td>
                                                            {historyReports.map((report, idx) => {
                                                                const value = getHistoryValueForTable(test._id, report.date, true, breakdown.name);
                                                                return (
                                                                    <td key={idx} className='text-center value-cell'>
                                                                        {value || '-'}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </CustomModal>
    );
};

export default HistoryModal;
